import styles from './Separator.module.scss';

export const Separator = () => <div className={styles.wrap} />;
